export function base64UrlDecode(encoded: string) {
  // Replace Base64URL chars with standard Base64 chars
  let base64 = encoded.replace(/-/g, "+").replace(/_/g, "/");

  // Pad with '=' to make length a multiple of 4
  const padding = base64.length % 4;
  if (padding) {
    base64 += "=".repeat(4 - padding);
  }

  return atob(base64);
}

export function base64UrlEncode(str: string) {
  // Convert string to base64
  const base64 = btoa(str);

  // Make it URL-safe: replace +, / and remove =
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
